import HighchartTranslations from "../HighchartsWrapper/highcharts.translations";
import HighchartOptions from "../HighchartsWrapper/highcharts.options";
import Highcharts from 'highcharts/highstock'

/**
 * @typedef ChartOptions
 * @prop {string} title
 * @prop {string} subtitle
 * @prop {string} yTitle
 * @prop {string} name
 * @prop {any} data
 * 
 * @param {ChartOptions} param0 
 * @returns 
 */
export function getOptions({
    title,
    subtitle,
    yTitle,
    name,
    data
}) {

    let translations = HighchartTranslations('it-IT')
    HighchartOptions(Highcharts, 'it-IT', translations)

    return {
        credits: {
          enabled: false
        },
      
        rangeSelector: {
          enabled: true, // (response.mode == 'web'),
          allButtonsEnabled: true,
          buttons: [{
            type: 'month',
            count: 1,
            text: translations.rangeSelector.month1
          }, {
            type: 'month',
            count: 3,
            text: translations.rangeSelector.month3
          }, {
            type: 'month',
            count: 6,
            text: translations.rangeSelector.month6
          }, {
            type: 'ytd',
            text: translations.rangeSelector.ytd
          }, {
            type: 'year',
            count: 1,
            text: translations.rangeSelector.year1
          }, {
            type: 'all',
            text: translations.rangeSelector.all
          }],
          
          buttonTheme: {
            width: 35
          },
      
          selected: 2,
      
          inputDateFormat: '%e %b %Y'
      
        },
        
        exporting: {
          sourceWidth: 841,
          sourceHeight: 595,
          scale: 1,
          chartOptions: {
            rangeSelector: {
              enabled: false
            }
          }
        },
    
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom'
        },
    
        navigator: {
          enabled: true // (response.mode == 'web')
        },
    
        scrollbar: {
          enabled: true // (response.mode == 'web')
        },
      
        title: {
          text: title
        },
      
        subtitle: {
          text: subtitle
        },
      
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e. %b',
            week: '%e. %b',
            month: '%b \'%y',
            year: '%Y'
          },
          xDateFormat: '%e'
        },
      
        yAxis: {
          title: {
              text: yTitle
          },
          opposite: false
        },
    
        series: [{
          name: name,
          data: data,
          tooltip: {
            valueDecimals: 2,
            dateTimeLabelFormats: {
              day: '%e. %b',
              week: '%e. %b',
              month: '%b \'%y',
              year: '%Y'
            }
          },
          dataGrouping: {
            dateTimeLabelFormats: {
              week: [translations.dataGrouping.week + "%A, %b %e, %Y"],
            }
          }          
        }]
      }
}
